/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHeartFill: {
  name: 'heart-fill';
  data: string;
} = {
  name: 'heart-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 3C3.732 3 1 5.412 1 8.973c0 3.449 2.015 5.96 4.239 7.795 1.117.922 2.32 1.701 3.413 2.367.413.252.802.482 1.164.697.623.37 1.168.692 1.63 1a1 1 0 0 0 1.109 0c.46-.308 1.006-.63 1.628-1 .363-.215.751-.445 1.165-.697 1.093-.666 2.296-1.445 3.413-2.367C20.985 14.933 23 12.422 23 8.973 23 5.412 20.268 3 17 3c-2.304 0-3.993 1.17-5 2.284C10.993 4.17 9.304 3 7 3Z" fill="currentColor"/></svg>`,
};
